import filter from 'lodash/filter';
import head from 'lodash/head';

export class OurStaffService {
	constructor($resource, ApiService) {
		'ngInject';

		this.$resource = $resource;
		this.apiService = ApiService;

		this.ourStaffResourceUrl = this.apiService.getResourceUrl('menus/OurStaff');

		this.ourStaffResource = this.$resource(this.ourStaffResourceUrl);
	}

	_getOverviewDetailsObject(details) {
		return {
			contentId: details.content_id,
			menuId: details.menu_id,
			displayName: details.display_name,
			name: details.name,
			title: details.title,
			description: details.description
		}
	}

	_getContentObject(values) {
		let details = filter(values, ['name', 'Staff']);
		return _getContentData(head(details).values);

		function _getContentData(data) {
			return data.map(value => ({
				firstName: value.first_name,
				lastName: value.last_name,
				createdAt: value.created_at,
				designation: value.designation,
				sortOrder: value.sort_order,
				image: value.image
			}));
		}
	}

	_getPhoneDetailsObject(value) {
		return value.map(({ extn, number }) => ({ extn, number }));
	}

	_getContactObject(values) {
		return values.reduce((year, data) => {
			if (data.name === 'Contact') {
				year = year.concat(_getContactData.call(this, data.values));
			}
			return year;
		}, []);

		function _getContactData(data) {
			return data.map(value => (this._getPhoneDetailsObject(value.phone)));
		}
	}

	getOurStaffDetails(details) {
		return {
			menuOverviewDetails: this._getOverviewDetailsObject(details.data.menuOverviewDetails),
			contact: this._getContactObject(details.data.content),
			details: this._getContentObject(details.data.content)
		};
	}
}


// WEBPACK FOOTER //
// ./src/app/components/about-us-our-staff/about-us-our-staff.service.js